import { render } from "./donation-faq.vue?vue&type=template&id=76d4383d&scoped=true"
import script from "./donation-faq.vue?vue&type=script&lang=js"
export * from "./donation-faq.vue?vue&type=script&lang=js"

import "./donation-faq.vue?vue&type=style&index=0&id=76d4383d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d4383d"]])

export default __exports__